import { useState } from 'react';
import EditIcon from '../../../assets/icons/editBlue.svg';
import ModalContainer from '../../modalContainer';
import ModalNewUser from '../modalNewUser';

function UserRoleRow({ item,userCreated }) {
  const [modalEditUser, setEditUser] = useState(false);

  return (
    <>
      {modalEditUser && (
        <ModalContainer>
          <ModalNewUser
            typeModal={'edit'}
            item={item}
            setEditUser={setEditUser}
            userCreated={userCreated}
          />
        </ModalContainer>
      )}
      <div className='info-container'>
        <p className='school-option'>{item?.role?.name}</p>
        <p className='school-option'>{item?.document}</p>
        <p className='school-option'>{item?.full_name}</p>
        <p className='school-option'>{item?.email}</p>
        <p className='school-option'>{item?.active?'ACTIVO':'INACTIVO'}</p>
        <button onClick={() => setEditUser(true)} className='school-option'>
          <img src={EditIcon} alt='' />
        </button>
      </div>
    </>
  );
}

export default UserRoleRow;
